import { render, staticRenderFns } from "./InactiveMonitoringPointList.vue?vue&type=template&id=2672753e&scoped=true&"
import script from "./InactiveMonitoringPointList.vue?vue&type=script&lang=js&"
export * from "./InactiveMonitoringPointList.vue?vue&type=script&lang=js&"
import style0 from "./InactiveMonitoringPointList.vue?vue&type=style&index=0&id=2672753e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672753e",
  null
  
)

/* custom blocks */
import block0 from "./InactiveMonitoringPointList.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2672753e')) {
      api.createRecord('2672753e', component.options)
    } else {
      api.reload('2672753e', component.options)
    }
    module.hot.accept("./InactiveMonitoringPointList.vue?vue&type=template&id=2672753e&scoped=true&", function () {
      api.rerender('2672753e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Sensor/InactiveMonitoringPointList.vue"
export default component.exports